<template>
  <vue-seamless-scroll :data="data" :class-option="optionLeft" class="service-case">
    <div class="item" v-for="(item, index) in data" :key="index">
      <a :href="item.content" target="_blank">
        <img :src="item.linkAddress" alt="" class="bg">
        <div class="logo">
          <img :src="item.logo" alt="">
        </div>
        <div class="desc">
          <p>{{ item.title }}{{ item.subtitle && `：${item.subtitle}` }}</p>
        </div>
      </a>
    </div>
  </vue-seamless-scroll>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'ServiceCase',
  components: {
    vueSeamlessScroll
  },
  computed: {
    optionLeft() {
      return {
        direction: 2, //滚动方向
        limitMoveNum: 2,
      }
    }
  },
  data() {
    return {
      data: [
        require('@/assets/image/new-enterprise/16.png'),
        require('@/assets/image/new-enterprise/1.png'),
        require('@/assets/image/new-enterprise/11.png'),
        require('@/assets/image/new-enterprise/2.png'),
        require('@/assets/image/new-enterprise/3.png'),
        require('@/assets/image/new-enterprise/4.png'),
        require('@/assets/image/new-enterprise/17.png'),
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let arr = [
        {
          "linkAddress": "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E4%B8%87%E8%A1%97.png",
          "title": "万街商业",
          "type": 1,
          "top": 0,
          "subtitle": "35城布局、160万平管理、超400亿资产，是国内领先的社区商业集成服务商",
        },
        {
          "linkAddress": "https://ow-resource.gousii.com/image%2F%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E6%B9%BE%E6%B5%81.png",
          "title": "湾流国际",
          "subtitle": "白领公寓先行者，成功运营118个高端社区，管理超35000套房源",
        },
        {
          "linkAddress": "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E4%B8%B0%E4%B9%90%E5%AE%B6.png",
          "title": "丰乐家",
          "subtitle": "顺丰全资控股的直营公寓品牌，已成功运营15家门店，服务超4000名顺丰员工",
          "status": 1
        },
        {
          "linkAddress": "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E6%97%BA%E9%93%BA%E9%80%9A%E9%9B%B6%E5%94%AE.png",
          "title": "旺铺通零售",
          "subtitle": "汇聚全球，服务万家，美好生活从这里启航",
          "status": 1
        },
        {
          "linkAddress": "https://ow-resource.gousii.com/image%2F%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E5%8D%83%E5%9F%8E%E9%9B%86%E5%9B%A2.png",
          "title": "千城集团",
          "subtitle": "致力成为中国领先的城市更新运营服务商",
          "status": 1
        },
        {
          "linkAddress": "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-HiveBEST.png",
          "title": "HiveBEST",
          "subtitle": "整合全球大家居产品供应链、提供一站式闭环式服务",
          "status": 1
        },
        {
          "linkAddress": "https://ow-resource.gousii.com/image/%E5%AE%A2%E6%88%B7%E6%95%85%E4%BA%8B-%E6%97%BA%E9%93%BA%E9%80%9A.png",
          "title": "旺铺通",
          "subtitle": "为1000万中小商户提供专业的社区商业运营服务",
          "status": 1
        },

      ]
      let data = arr.map((item, index) => {
        item.logo = this.data[index]
        return item
      })
      this.data = data
    }
  }
}
</script>

<style lang='less' scoped>
.service-case {
  width: 440px * 7;

  .item {
    width: 400px;
    overflow: hidden;
    background: #FFFFFF;
    border-radius: 8px;
    margin: 10px 30px 10px 10px;
    box-shadow: 0 0 5px #EAEEF9;
    display: inline-block;
    position: relative;

    a {
      display: block;
    }

    .bg {
      width: 100%;
      height: 200px;
      transition: all 0.5s ease-in-out;
    }

    .logo {
      position: absolute;
      top: 150px;
      left: 30px;
      width: 90px;
      height: 90px;
      line-height: 90px;
      border-radius: 100%;
      box-shadow: 0 4px 10px #DDDDDD;
      background: #FFFFFF;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    .desc {
      padding: 60px 30px 30px;

      p {
        margin: 0;
        height: 60px;
        font-size: 18px;
        color: #333333;
      }
    }

    &:hover {
      box-shadow: 5px 5px 15px #CCCCCC;

      .bg {
        transform: scale(1.05);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .service-case {
    width: 270px * 7;

    .item {
      width: 240px;
      margin: 10px 20px 10px 10px;

      .bg {
        height: 120px;
      }

      .logo {
        top: 90px;
        left: 20px;
        width: 60px;
        height: 60px;
        line-height: 60px;
      }

      .desc {
        padding: 40px 20px 20px;

        p {
          height: 72px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>